import { ConditionalRender, OrganTypeBadge } from '@ui';
import { OrganType } from '@/api/apis/case';

const ORGAN_ORDER: OrganType[] = [OrganType.Liver, OrganType.Heart, OrganType.Lungs];

const sortOrgans = (organs?: OrganType[]) => {
  if (!organs?.length) return [];
  return ORGAN_ORDER.filter((organ) => organs.includes(organ));
};

type OrganSectionProps = {
  label: string;
  organs?: OrganType[];
  show?: boolean;
  showBackground?: boolean;
};

export const OrganSection = ({ label, organs, show = true, showBackground = true }: OrganSectionProps) => {
  const sortedOrgans = sortOrgans(organs);

  if (!show || !sortedOrgans.length) return null;

  return (
    <ConditionalRender show={show && !!sortedOrgans.length}>
      <div className="flex flex-col items-stretch gap-1">
        <p className="text-m-r text-base-20">{label}</p>
        <div className="flex gap-2">
          {sortedOrgans.map((organ) => (
            <div className="flex flex-row items-center" key={organ}>
              <OrganTypeBadge organ={organ} size="md" bgTone="bg40" showBackground={showBackground} />
              <p className="text-l-r pl-2">{organ}</p>
            </div>
          ))}
        </div>
      </div>
    </ConditionalRender>
  );
};
